module.exports = __webpack_public_path__ + "media/images/social-share-button/twitter-OLD-ee390c342f9f90074a888fcb1d1c3e55.svg";